import type { Events } from "@outschool/data-schemas";

import type { EventOptions, SendTrackEventWithSchema } from "../types";
import type { IntegrationCategory } from "../providers/AnalyticsContext";

import React from "react";

import useTrackEvent from "./useTrackEvent";

export default function useTrackEventWithSchema(
  category?: IntegrationCategory
): SendTrackEventWithSchema {
  const trackEvent = useTrackEvent(category);

  return React.useCallback(
    (event: Events, options?: EventOptions, callback = () => {}) => {
      return trackEvent(event.event, event.data, options, callback);
    },
    [trackEvent]
  );
}
